/**
 * Tatsächlich eingegangener Betrag einer bezahlten Rechnung (KPI „Bezahlt“).
 * Ein Sicherheitseinbehalt ist nicht gezahlt, gezogenes Skonto auch nicht — beides zählt nicht mit.
 */

type Amount = number | string | null | undefined;

export type InvoiceReceivedAmountInput = {
  gross_amount?: Amount;
  /** Zahlbetrag = Brutto − eigener Einbehalt (+ fällige Vor-Einbehalte auf der Schlussrechnung). */
  payable_amount?: Amount;
  /** Beim Bezahlt-Markieren erfasster Zahlungseingang. */
  paid_amount?: Amount;
  skonto_amount?: Amount;
  skonto_taken?: boolean | null;
};

function toFiniteNumber(value: Amount): number | null {
  if (value == null || value === '') return null;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? n : null;
}

export function invoiceReceivedAmount(row: InvoiceReceivedAmountInput): number {
  const paid = toFiniteNumber(row.paid_amount);
  if (paid != null) return paid;
  const payable = toFiniteNumber(row.payable_amount) ?? 0;
  const base = payable > 0 ? payable : (toFiniteNumber(row.gross_amount) ?? 0);
  const skonto = row.skonto_taken ? Math.max(0, toFiniteNumber(row.skonto_amount) ?? 0) : 0;
  return Math.round((base - Math.min(skonto, Math.max(0, base))) * 100) / 100;
}
